import {ORM} from 'redux-orm';
import * as Models from './models';

const orm = new ORM({
  stateSelector: state => state.orm,
});
orm.register(...Object.values(Models));

export default orm;
